import React, { Component } from 'react'
import { Row, Col, Collapse, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import EirButton from '../../eir-button/EirButton';
import EirEditExpiry from './EirEditExpiry';
import Loading from '../../shared/Loading';
import { RealexHpp }  from '../rxp-js';
import EirErrorModal from '../EirErrorModal';
import { payer,csrPayer, addCard,csrAddCard } from '../apis/accountManagementApis';

class PaymentDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,           
            modal: false,
            payer: [],
            cardNumber: '',
            expiry: '',
            addCard: '',
            payerRef: '',
            cardId: '',
            csrPayerUrl:'',
            csrPayerParam:'',
            csrGenerateUrl:'',
            csrGenerateParam:'',            
            csrProcessParam:'',
            errorModal: false,
            setCardDefaultModel: false,
            loading: false,
            iFrameLoading: false,
            statusChanged: false
        }
        
    }

    
    componentDidMount() {
        
        if (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN')  === '0_') {
            this.state.csrPayerUrl = csrPayer;            
            this.state.csrPayerParam = `/`;
            this.state.csrGenerateUrl = csrAddCard;
            this.state.csrGenerateParam = `/generate/`;            
            this.state.csrProcessParam = `/process/`;
        }else {
            this.state.csrPayerUrl = payer;
            this.state.csrPayerParam = '/';
            this.state.csrGenerateUrl = addCard;
            this.state.csrGenerateParam = `/generate`;        
            this.state.csrProcessParam = `/process`;           
        }
        this.payer();
    }

    toggleError = (param) => {
        this.setState({
            errorModal: param
        })
    }

    payer = () => {
        this.setState({
            loading: true
        })
            this.state.csrPayerUrl.get(this.state.csrPayerParam)
            .then((response) => {
                this.setState({
                    payer: response.data.cards,
                    payerRef: response.data.payerRef,
                    loading: false,
                    statusChanged: !this.state.statusChanged
                })
            })
            .catch((error) => {
                console.log('error', error)
                if (error.response.status === 401) {
                    return window.location.href = '/email/login'
                }
                this.setState({
                    errorModal: true,
                    loading: false
                })
            });
    }

    toggle = (event) => {
        event.preventDefault();

        this.setState({
            isOpen: !this.state.isOpen
        })
        

        if (!this.state.isOpen) {
            this.setState({
                iFrameLoading: true
            })

            this.state.csrGenerateUrl.post(this.state.csrGenerateParam, {
                    "payerReference": this.state.payerRef
            })
            .then((response) => {
                this.setState({
                    addCard: response.data,
                    iFrameLoading: false
                })

                RealexHpp.embedded.init(
                    "addCard",
                    "payment-iframe",
                    "localhost",
                    response.data.hppRequest,
                    this.submitCard,
                );
            })
            .catch((error) => {
                console.log('error', error)
                if (error.response.status === 401) {
                    return window.location.href = '/email/login'
                }
                this.setState({
                    errorModal: true,
                    iFrameLoading: false,
                })
            })

        }
    }

    submitCard = (hpp) => {
        this.setState({
            isOpen: !this.state.isOpen
        })

        this.state.csrGenerateUrl.post(this.state.csrProcessParam, {
                "encoded": true,
                "hppResponse": hpp
        })
            .then((response) => {
                this.payer();
            })
            .catch((error) => {
                console.log('error', error)
                if (error.response.status === 401) {
                    return window.location.href = '/email/login'
                }
                this.setState({
                    errorModal: true
                })
            });
    }

    toggleModel = (cardNumber, cardId, expiry) => e => {
        this.setState({
            modal: !this.state.modal,
            cardNumber,
            expiry,
            cardId
        })
    }

    handleRemeveCard = e => {
        this.setState({
            modal: !this.state.modal
        })

        this.state.csrPayerUrl.delete(`${this.state.csrPayerParam}card_payment_method/${this.state.cardId}`)
        .then((response) => {
            this.payer();
        })
        .catch((error) => {
            console.log('error ', error);
            if (error.response.status === 401) {
                return window.location.href = '/email/login'
            }
            this.setState({
                errorModal: true
            })
        })
    }
    
    handleCardDefaultModel = (cardNumber, cardId) => e => {
        
        this.state.csrPayerUrl.post(`${this.state.csrPayerParam}card_payment_method/${cardId}/update_default_credit_card`)
            .then((response) => {
            this.setState({
                cardNumber,
                setCardDefaultModel: !this.state.setCardDefaultModel
            })
            this.payer();
        }).catch((error) => {
            console.log('error ', error);
            if (error.response.status === 401) {
                return window.location.href = '/email/login'
            }
            this.setState({
                errorModal: true
            })
        })
    }

    closeDefaultCardModel = () => {
        this.setState({
            setCardDefaultModel: !this.state.setCardDefaultModel
        })
    }

    render() {
        return (
            <div className='paymment-details-main'>
                <Row>
                    <Col>
                        {   this.state.payer.length !== 0 &&
                        <Row>
                            <Col xs='1' sm='1' lg='1' md='1'></Col>
                            <Col xs='5' sm='5' lg='4' md='6'><b>Card Number</b></Col>
                            <Col xs='5' sm='5' lg='3' md='4'><b>Expiry Date</b></Col>
                            <Col xs='6' sm='7' lg='2' md='7'></Col>
                            <Col xs='6' sm='5' lg='2' md='5'></Col>
                        </Row>
                        }
                        {   this.state.payer !== [] &&
                            this.state.payer.map((card, i) => {
                                const { partialDigits,  expirationDate } = card;
                                let date = expirationDate.split('-');
                                let expiry = date[1] + '/' + date[0];
                                return (
                                    <Row className='mt-4 mb-4' key={i}>
                                        <Col xs='1' sm='1' lg='1' md='1'>
                                            <input type="radio" name="radio1" checked={ card.default } onChange={this.handleCardDefaultModel(partialDigits, card.cardId)} />{' '}
                                        </Col>
                                        <Col className='card-details-text' xs='5' sm='5' lg='4' md='6'>{ partialDigits }</Col>
                                        <EirEditExpiry statusChanged={this.state.statusChanged} expiry={ expiry } cardId={ card.cardId } email={this.props.email} />
                                        <Col xs='6' sm='5' lg='2' md='5'>
                                            <EirButton type='link' text='Delete Card' className='delete-card' disabled={ card.default } onClick={this.toggleModel(partialDigits, card.cardId, expiry)} />                                            
                                        </Col>
                                    </Row>
                                )
                            })
                        }
                        <Modal isOpen={this.state.modal} centered={true} toggle={this.toggleModel()}>
                            <ModalHeader toggle={this.toggleModel()}>Delete this Card</ModalHeader>
                            <ModalBody>
                                <p>Are you sure you want to delete this card?</p>
                                <p><b>Card Number: </b>{this.state.cardNumber}</p> 
                                <p><b>Expiry: </b>{this.state.expiry}</p>
                            </ModalBody>
                            <ModalFooter className='paymment-details-main'>
                                <EirButton className='webmail-btn' type='button' text='YES' onClick={this.handleRemeveCard}></EirButton>{' '}
                                <EirButton className='webmail-btn btn-outline-primary eir-text-secondary' color='white' type='button' text='NO' onClick={this.toggleModel()}></EirButton>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.setCardDefaultModel} centered={true} toggle={this.closeDefaultCardModel}>
                            <ModalHeader toggle={this.closeDefaultCardModel}>Default Card</ModalHeader>
                            <ModalBody>
                                Card: {this.state.cardNumber} is set to default.
                            </ModalBody>
                            <ModalFooter className='paymment-details-main'>
                                <EirButton className='webmail-btn' type='button' text='Done' onClick={this.closeDefaultCardModel}></EirButton>
                            </ModalFooter>
                        </Modal>
                    </Col>
                </Row>
                {
                    this.state.loading &&
                    <Loading />
                }
                <Row>
                    <Col>
                        {
                            !this.state.iFrameLoading &&
                            <Collapse isOpen={this.state.isOpen}>
                                <iframe
                                    id="payment-iframe"
                                    frameBorder="0"

                                    style={{
                                        display: 'inline-block',
                                        width: '100%',
                                        align: 'centre',
                                        minHeight: '650px',
                                        position: 'relative',
                                        marginTop: '1rem'
                                    }}
                                />
                            </Collapse>
                        }
                        
                        {
                            this.state.iFrameLoading &&
                            <div className="add-card-loader text-center mt-5 text-secondary mt-4" >
                                <Loading />
                            </div>
                        }  
                        <div className='add-new-card'>
                            <EirButton text={!this.state.isOpen ? 'Add new card' : 'Cancel'} id='addCard' className='webmail-btn' type='button' onClick={this.toggle} />
                        </div>
                    </Col>
                </Row>
                {
                    this.state.errorModal &&
                    <EirErrorModal toggleError={this.toggleError} errorModal={this.state.errorModal} />
                }
            </div>
        )
    }
}

export default PaymentDetails;